import { useQuery } from '@apollo/client';
import { useParams, useNavigate } from 'react-router';

import { UserMutations } from './user_mutations_container';
import {
  BackofficeScopesQuery,
  BackofficeScopesQueryVariables,
  UserQuery,
  UserQueryVariables,
} from '../../lib/graphql';
import { Loader } from '../../lib/loader';
import { UserView, UserViewDataProps } from '../components/user';
import { backofficeScopesQuery, userQuery } from '../graphql';

class LoadingContainer extends Loader<UserQuery, UserViewDataProps, UserQueryVariables> {}
class BackofficeScopesLoadingContainer extends Loader<
  BackofficeScopesQuery,
  { data: { backofficeScopes: string[] | undefined } },
  BackofficeScopesQueryVariables
> {}

export const UserContainer = () => {
  const { user_id } = useParams() as { user_id: string };
  const navigate = useNavigate();
  const isNewUser = user_id === 'new';

  const result = useQuery<UserQuery, UserQueryVariables>(userQuery, {
    variables: { user_id },
    skip: isNewUser,
  });

  const scopesResult = useQuery<BackofficeScopesQuery, BackofficeScopesQueryVariables>(backofficeScopesQuery);

  return (
    <BackofficeScopesLoadingContainer
      result={scopesResult}
      mapData={({ data }) => ({
        data: {
          backofficeScopes: data.backofficeScopes,
        },
      })}>
      {({ data: scopesData }) => {
        if (isNewUser) {
          return (
            <UserMutations>
              {({ createUser }) => {
                return (
                  <UserView
                    isNewUser={isNewUser}
                    createUser={createUser}
                    routeProps={{ push: (path: string) => navigate(path), goBack: () => navigate(-1) }}
                    scopes={scopesData.backofficeScopes ?? []}
                  />
                );
              }}
            </UserMutations>
          );
        }

        return (
          <UserMutations>
            {({ updateUser, deleteUser, removeCredentialsFromUser, addCredentialsToUser }) => {
              return (
                <LoadingContainer
                  result={result}
                  mapData={({ data }) => ({
                    data: { user: data.user },
                  })}>
                  {({ data }) => (
                    <UserView
                      isNewUser={false}
                      data={data}
                      updateUser={updateUser}
                      deleteUser={deleteUser}
                      removeCredentialsFromUser={removeCredentialsFromUser}
                      addCredentialsToUser={addCredentialsToUser}
                      routeProps={{ push: (path: string) => navigate(path), goBack: () => navigate(-1) }}
                      scopes={scopesData.backofficeScopes ?? []}
                    />
                  )}
                </LoadingContainer>
              );
            }}
          </UserMutations>
        );
      }}
    </BackofficeScopesLoadingContainer>
  );
};
